import type { StripeError, StripeErrorType } from '@stripe/stripe-js';

import type { StripeSetupFailure } from '#src/app/shared/utils/payments';

export function mapGatewayErrorToStripeError(
	error: StripeSetupFailure & { gatewayErrorData: NonNullable<StripeSetupFailure['gatewayErrorData']> },
): StripeError {
	return {
		type: error.gatewayErrorData.type as StripeErrorType,
		code: error.gatewayErrorData.code ?? undefined,
		decline_code: error.gatewayErrorData.declineCode ?? undefined,
	};
}
